import { StatusChipColor } from "components/StatusChip";
import { ActivityStatus, WorkflowStatus } from "generated-graphql/graphql";

/**
 * Chip roles for the workflow lifecycle, shared by every Work surface (queue
 * drawer, custom-deliverable detail header) so one status never reads green in
 * one place and grey in another. Exhaustive records on purpose: a new enum
 * member fails the build here instead of silently falling back to grey.
 */
const WORKFLOW_STATUS_COLOR: Record<WorkflowStatus, StatusChipColor> = {
  [WorkflowStatus.NotStarted]: "default",
  [WorkflowStatus.InProgress]: "info",
  [WorkflowStatus.Completed]: "success",
  [WorkflowStatus.Error]: "error",
  [WorkflowStatus.Paused]: "warning",
  [WorkflowStatus.Canceled]: "default",
};

export function workflowStatusColor(status: WorkflowStatus): StatusChipColor {
  return WORKFLOW_STATUS_COLOR[status];
}

/**
 * Activity (step) statuses. Skipped is a first-class terminal state, not a
 * failure, so it stays neutral rather than borrowing the error role.
 */
const ACTIVITY_STATUS_COLOR: Record<ActivityStatus, StatusChipColor> = {
  [ActivityStatus.NotStarted]: "default",
  [ActivityStatus.Queued]: "default",
  [ActivityStatus.InProgress]: "info",
  [ActivityStatus.Completed]: "success",
  [ActivityStatus.StaffCompleted]: "success",
  [ActivityStatus.Skipped]: "default",
  [ActivityStatus.Canceled]: "default",
  [ActivityStatus.Error]: "error",
};

export function activityStatusColor(status: ActivityStatus): StatusChipColor {
  return ACTIVITY_STATUS_COLOR[status];
}
